<template>
<div :class="['content-box', { 'no-card': disableCard }]">
  <div class="m-2 pl-3 text-center" v-show="isLoading">
    <font-awesome-icon
      :icon="['fa', 'circle-notch']"
      class="fa-spin m-auto spinner fa-5x egx-partner-color"
    />
  </div>
  <div v-if="(applications?.length || 0) < 1" v-show="!isLoading">
    <p
      v-if="fulfill_sync_details.pages?.applications?.no_content"
      :class="fulfill_sync_details.pages.applications.no_content.class"
      :style="fulfill_sync_details.pages.applications.no_content.style"
      v-safe-html="fulfill_sync_details.pages.applications.no_content.text"
    />
  </div>
  <div v-else>
    <div :class="['card-body', { 'no-card': disableCard }]" v-for="(application, index) in applications">
      <div class="row">
        <div class="col-lg-8">
          <div>
            <span class="egx-partner-color">
              <h4>{{ getProgramName(application.program_id) || application.name }}</h4>
            </span>
          </div>
          <div>
            <b>{{ fulfill_sync_details.pages?.applications?.fields_labels?.id || 'Application Id: ' }}</b>
            <span><router-link :to="`/applications/${application.id}`" class="egx-partner-color">{{ application.id }}</router-link></span>
          </div>
          <div v-if="fulfill_sync_details.pages?.applications?.display_building_address">
            <b>{{ fulfill_sync_details.pages?.applications?.fields_labels?.building_address || 'Building Address: ' }}</b>
            <span>{{currentBuilding?.address1 }} - {{currentBuilding?.city }}, {{currentBuilding?.country }}</span>
          </div>
          <div>
            <b>{{ fulfill_sync_details.pages?.applications?.fields_labels?.status || 'Status: ' }}</b>
            <span v-safe-html="sanitizeHTML(application.custom_status_description || application.status)" />
          </div>
          <div>
            <p>{{ application.description }}</p>
          </div>
          <div class="mt-4">
            <b>{{ fulfill_sync_details.pages?.applications?.fields_labels?.updated_at || 'Last Updated: ' }}</b>
            <span>{{ application.custom_status_date || formatDate(application.last_modified_ts) }}</span>
          </div>
        </div>
        <div class="col-lg-4 d-flex flex-column justify-content-center align-items-center">
          <button class="btn btn-egx  mb-2" style="height: 3rem; width: 10rem;" @click="viewApplication(application.id)" v-if="settings.display_applications_view_button">View</button>
          <button class="btn btn-warning" style="height: 3rem; width: 10rem;" @click="updateApplication(application.id)" v-if="!locked(application)">Update</button>
        </div>
      </div>
      <hr v-if="index < applications.length - 1" />
    </div>
  </div>
</div>
</template>

<script>
import DOMPurify from 'dompurify';
import projectMixins from '@/shared/mixins/projectMixins';

export default {
  components: {
  },
  mixins: [projectMixins],
  data() {
    return {
      applications: [],
      programs: [],
      disableCard: false,
      isLoading: false,
    };
  },

  created() {
    this.isLoading = true;
    this.$store.dispatch('fulfill_integrate/getProjects').then(() => {
      this.applications = this.$store.state.fulfill_integrate.projects;

      if (this.applications) {
        if (this.currentBuilding.partner_building_id) {
          this.applications = this.applications.filter((application) => application.site_id == this.currentBuilding.partner_building_id);
        }
        this.applications.sort((a, b) => {
          const dateA = new Date(a.custom_status_date || this.formatDate(a.last_modified_ts));
          const dateB = new Date(b.custom_status_date || this.formatDate(b.last_modified_ts));
          return dateB - dateA;
        });
      }

      this.programs = this.$store.state.fulfill_integrate.programs;
      this.$emit('number-of-applications', (this.applications?.length || 0));
      this.isLoading = false;
    }).catch((error) => {
      console.log(error.message);
      this.$notify({
        group: 'notice-stay',
        type: 'error',
        text: error.message,
      });
    })
    .finally(() => {
      this.isLoading = false;
    });
  },
  methods: {
    updateApplication(id) {
      this.$store.dispatch('fulfill_integrate/get_project_selected', { project_id: id })
      .then(() => {
        this.$router.push(`/applications/${id}/edit?step=1`);
      })
      .catch((error) => {
        this.isVisible = false;
        console.log(error);
      });
    },
    viewApplication(id) {
      this.$router.push(`/applications/${id}`);
    },
    formatDate(dateString) {
      return new Date(dateString).toUTCString();
    },
    sanitizeHTML(html) {
      return DOMPurify.sanitize(html);
    },
    getProgramName(programId) {
      const program = this.programs.find(prog => prog.id === programId);
      return program ? program.effective_program_name : null;
    },
  },
  computed: {
    settings() {
      return this.$store.state.partners.currentPartner.settings;
    },

    fulfill_sync_details() {
      return this.settings.fulfill_sync_details;
    },

    currentBuilding() {
      return this.$store.state.buildings.currentBuilding;
    }
  }
}
</script>

<style scoped>
.card-body {
  margin-bottom: 10px;
}
hr {
  margin-bottom : -2rem;
}
.egx-partner-color {
  color: inherit;
}

@media (max-width: 991px) {
  .col-lg-4 {
    margin-top: 1.5rem;
  }
}
</style>
